import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import type { MessageKey } from '../../../../configuration';
import { historyActionInfoMessageKeys } from './historyActionMessages';

const DialogBody = () => (
    <div>
        <table className={'table'}>
            <thead>
                <tr>
                    <th>
                        <FormattedMessage id={'marketplace.history.header.action'} />
                    </th>
                    <th>
                        <FormattedMessage id={'marketplace.description'} />
                    </th>
                </tr>
            </thead>
            <tbody>
                {historyActionInfoMessageKeys.map(action => {
                    const description: MessageKey = `${action}.descr`;
                    return (
                        <tr key={action}>
                            <td className={'white-space-nowrap'}>
                                <FormattedMessage id={action} />
                            </td>
                            <td>
                                <FormattedMessage id={description} />
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>
);

export const HistoryActionInfo = () => {
    const [open, setOpen] = useState(false);
    return (
        <span className={'margin-left-10'}>
            <Button variant={Button.VARIANT_ACTION} bsSize={Button.XS} iconOnly onClick={() => setOpen(true)}>
                <span className='uikit-icon icon-info-sign text-color-gray' />
            </Button>
            <Dialog
                title={<FormattedMessage id='marketplace.action.info.title' />}
                show={open}
                body={<DialogBody />}
                onClose={() => setOpen(false)}
                showCloseButton={true}
            />
        </span>
    );
};
